import React from 'react';
import { AppComponent } from 'utils/components';

export default function ListItem(props: { component: AppComponent }) {
	console.warn('unimplemented', props.component);

	return <div>list item</div>;
}
